module.exports = __webpack_public_path__ + "img/Shetland_Islands.a74f1d31.png";